"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var _menu = require("../menu");

var _messages = require("../../../constants/messages");

var _routes = require("../../../constants/routes");

var EventsMenu = function EventsMenu(_ref) {
  var activeListItem = _ref.activeListItem,
      customLinkRenderer = _ref.customLinkRenderer,
      onItemMouseEnter = _ref.onItemMouseEnter,
      onItemMouseLeave = _ref.onItemMouseLeave;
  var isActive = _.NAV_MENUS.MATCH_EVENTS === activeListItem;
  return _react.default.createElement(_menu.MenuItem, {
    altCountBadge: false,
    customLinkRenderer: customLinkRenderer,
    icon: "events",
    id: _.NAV_MENUS.MATCH_EVENTS,
    isSelected: isActive,
    label: _messages.MESSAGE_ID.EVENTS_MENU,
    onMouseEnter: onItemMouseEnter,
    onMouseLeave: onItemMouseLeave,
    route: _routes.ROUTE.EVENTS,
    showIndicatorDot: false,
    subMenuUI: null
  });
};

var _default = EventsMenu;
exports.default = _default;